import { Injectable } from "@angular/core";
import { LegacyMeasurementService, Measurement } from "@evident/ngx-media-viewer";
import { MetadataService } from "@evident/ngx-metadata-writer";

@Injectable({ providedIn: "root" })
export class MerryMeasurementParserService {
  private metadataMeasurementTag = "Measurements";

  constructor(
    private metadataService: MetadataService,
    private _legacyMeasurementService: LegacyMeasurementService
  ) {
    this._legacyMeasurementService.config.requireImportConfirmation = false;
  }

  async parseMeasurementResults(imagePath: string): Promise<Measurement[]> {
    const [cleanPath] = imagePath.split("?"); // Remove query parameters for cache busting

    const measurements = await this.extractMeasurementFromMetadata(cleanPath);
    if (!measurements.length) await this.extractLegacyMeasurementFromMetadata(cleanPath);

    return measurements;
  }

  private async extractLegacyMeasurementFromMetadata(imageSrc: string) {
    const legacyMetadata = await this.metadataService.extractLegacyMetadata(imageSrc);

    // Subject to change when adressing this ticket: VISOL-2623
    await this._legacyMeasurementService.readLegacyMeasurements(this.deepJsonParse(legacyMetadata), imageSrc);
  }
  private async extractMeasurementFromMetadata(imageSrc: string): Promise<Measurement[]> {
    const metadata = await this.metadataService.extractMetadata(imageSrc);

    if (!metadata[this.metadataMeasurementTag]) {
      return [];
    }

    try {
      return JSON.parse(metadata[this.metadataMeasurementTag]) as Measurement[];
    } catch (e) {
      console.error("Failed to parse measurements from metadata", e);
      return [];
    }
  }
  private deepJsonParse<T>(input: unknown): T {
    function parseValue(val: unknown): unknown {
      let result = val;
      while (typeof result === "string") {
        try {
          result = JSON.parse(result);
        } catch {
          break;
        }
      }
      if (Array.isArray(result)) {
        return result.map(parseValue);
      }
      if (result && typeof result === "object") {
        const obj: Record<string, unknown> = {};
        for (const [key, value] of Object.entries(result)) {
          obj[key] = parseValue(value);
        }
        return obj;
      }
      return result;
    }
    return parseValue(input) as T;
  }
}
